module.exports = __webpack_public_path__ + "static/media/call-inprogress.686a3db3.svg";